import React from 'react';
import _ from 'lodash';
import MyMentorCard from './MentorCard';
import { useModule } from '../../../../utils/useModule';
import { Box, Stack, Divider, Typography } from '@mui/material';
import useResponsiveScreenSwitch from '../../../../utils/useResponsiveScreenSwitch';

interface MyMentorCardProps {
  myMentorList: any;
  loading?: boolean;
  myRequestedMentorList?: any;
  doReload?: () => void;
  onMeetingScheduled?: (meetingDetails: any) => void;
}

const MyMentorSection: React.FC<MyMentorCardProps> = ({
  loading,
  doReload,
  myMentorList,
  myRequestedMentorList,
  onMeetingScheduled
}: MyMentorCardProps) => {
  const { isHybrid } = useModule();
  const { forMobile } = useResponsiveScreenSwitch(); // Use the hook
  const mentorCardCount = myMentorList?.length || 0;
  const requestedMentorCount = myRequestedMentorList?.length || 0;
  const totalMentorsFound = mentorCardCount > 0 || requestedMentorCount > 0;
  const totalMentorsCount = mentorCardCount + requestedMentorCount;
  let mentorsWithRequestFlag: any[];

  if (Array.isArray(myRequestedMentorList) && myRequestedMentorList.length > 0) {
    mentorsWithRequestFlag = myRequestedMentorList.map((mentor: any) => ({
      ...mentor,
      requestFlag: true
    }));
  } else {
    mentorsWithRequestFlag = [];
  }
  const totalMentors = [...mentorsWithRequestFlag, ...(myMentorList || [])];

  /** If this User no have any mentor  */
  function MentorNotFound() {
    return (
      <Box px={2} pt={{ md: isHybrid ? 3 : 5.6 }}>
        <Typography py={2} textAlign={'center'}>
          Find a mentor. Send a message. Schedule a meeting.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {!totalMentorsFound ? (
        <MentorNotFound />
      ) : (
        <Box px={1} pb={1} flex={1} height={'100%'}>
          <Box className="mentorsCardSection" height={'100%'}>
            <Stack
              direction={forMobile ? 'column' : 'row'}
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
              height={'100%'}
            >
              {totalMentorsCount &&
                _.uniqBy(totalMentors, 'displayName').map((each, index) => {
                  // only show 5 cards
                  return index < 5 ? (
                    <MyMentorCard
                      key={index}
                      mentor={each}
                      loading={loading}
                      doReload={doReload}
                      onMeetingScheduled={onMeetingScheduled}
                    />
                  ) : null;
                })}
            </Stack>
          </Box>
        </Box>
      )}
    </>
  );
};

export default MyMentorSection;
